import {
  Box,
  Flex,
  IconButton,
  HStack,
  Tooltip,
} from '@chakra-ui/react';
import { FaBars, FaQuestionCircle, FaHeadset } from 'react-icons/fa';
import NotificationsMenu from './NotificationsMenu';

interface AdminHeaderProps {
  onMenuClick: () => void;
}

const AdminHeader = ({ onMenuClick }: AdminHeaderProps) => {
  return (
    <Box
      as="header"
      bg="whiteAlpha.100"
      backdropFilter="blur(10px)"
      borderBottom="1px"
      borderColor="whiteAlpha.200"
      py={4}
      px={6}
    >
      <Flex justify="space-between" align="center">
        <IconButton
          display={{ base: 'flex', md: 'none' }}
          onClick={onMenuClick}
          icon={<FaBars />}
          variant="ghost"
          aria-label="Toggle Menu"
          color="gray.300"
          _hover={{ bg: 'whiteAlpha.200' }}
        />

        <Box flex={1} />

        <HStack spacing={4}>
          <NotificationsMenu />
          <Tooltip label="Help Center" placement="bottom">
            <IconButton
              icon={<FaQuestionCircle />}
              variant="ghost"
              aria-label="Help Center"
              color="gray.300"
              _hover={{ bg: 'whiteAlpha.200' }}
              onClick={() => window.open('/help', '_blank')}
            />
          </Tooltip>
          <Tooltip label="Support" placement="bottom">
            <IconButton
              icon={<FaHeadset />}
              variant="ghost"
              aria-label="Support"
              color="gray.300"
              _hover={{ bg: 'whiteAlpha.200' }}
              onClick={() => window.open('/support', '_blank')}
            />
          </Tooltip>
        </HStack>
      </Flex>
    </Box>
  );
};

export default AdminHeader;